<template>
  <div class="wificonfig" v-loading="loading">
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      label-width="150px"
      class="config-form"
    >
      <el-form-item label="WiFi名称" prop="ssid">
        <el-input v-model="formData.ssid" placeholder="请输入WiFi名称" />
      </el-form-item>
      <el-form-item label="WiFi密码" prop="password">
        <el-input v-model="formData.password" placeholder="请输入WiFi密码" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSave" :loading="saving">
          保存配置
        </el-button>
        <el-button @click="handleReset" :loading="resetting">
          重置为默认
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { useBaseAsync } from 'hpsfir-managebase-ui';
import { WifiSpe } from '@/api';

const formRef = ref<FormInstance>();
const saving = ref(false);
const resetting = ref(false);
const loading = ref(false);

const formData = reactive<WifiSpe>({
  ssid: '',
  password: '',
});

const rules: FormRules = {
  ssid: [{ required: true, message: '请输入WiFi名称', trigger: 'blur' }],
  password: [{ required: true, message: '请输入WiFi密码', trigger: 'blur' }],
};

// 加载配置
const loadConfig = useBaseAsync(async() => {
  loading.value = true;
  try {
    const res = await useApi().wifiApi.getWifiwifi();
    const { data } = res.data;
    if (data) {
      formData.ssid = data.ssid || '';
      formData.password = data.password || '';
    }
  } finally {
    loading.value = false;
  }
});

// 保存配置
const handleSave = useBaseAsync(async() => {
  await formRef.value?.validate();
  saving.value = true;
  try {
    await useApi().wifiApi.setWifiwifi({
      wifi: formData,
    });
    ElMessage.success('保存成功');
  } finally {
    saving.value = false;
  }
});

// 重置为默认
const handleReset = async() => {
  await ElMessageBox.confirm('确定要重置为默认配置吗？', '提示', {
    type: 'warning',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
  });
  resetting.value = true;
  try {
    await useApi().wifiApi.resetWifiwifi();
    ElMessage.success('重置成功');
    await loadConfig();
  } finally {
    resetting.value = false;
  }
};

onMounted(() => {
  loadConfig();
});
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
